import { alpha, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Chart, Line } from 'react-chartjs-2';

import MilestonesPropType from '../../proptypes/milestones';

const verticalLinePlugin = {
    id: 'verticalLine',
    afterDatasetDraw: function (chartInstance) {
        const ctx = chartInstance.ctx;
        const xScale = chartInstance.scales['x'];
        const yScale = chartInstance.scales['y'];
        chartInstance.config._config.options.milestones?.forEach((milestone) => {
            const style = 'rgba(42,98,143, .8)';
            ctx.lineWidth = 3;
            const xValue = xScale.getPixelForValue(milestone.time / 1000);
            ctx.beginPath();
            ctx.moveTo(xValue, yScale.top);
            ctx.lineTo(xValue, yScale.bottom);
            ctx.strokeStyle = style;
            ctx.stroke();
        });
    },
};
Chart.register(verticalLinePlugin);
function MetricChart({ title, metric, yDatasets, unit, options, milestones }) {
    const theme = useTheme();

    const chartData = {
        datasets: [
            {
                label: title,
                data: yDatasets[0]?.map((datapoint, index) => ({
                    x: index,
                    y: datapoint,
                })),
                fill: true,
                backgroundColor: alpha(theme.palette.primary.main, 0.3),
                borderColor: theme.palette.primary.main,
                lineTension: 0.2,
                pointRadius: 0,
            },
            {
                label: title + ' reference',
                data: yDatasets[1]?.map((datapoint, index) => ({
                    x: index,
                    y: datapoint,
                })),
                fill: true,
                backgroundColor: alpha(theme.palette.secondary.main, 0.3),
                borderColor: theme.palette.secondary.main,
                lineTension: 0.2,
                pointRadius: 0,
            },
            {
                showLine: false,
                display: false,
                label: '',
                data: [
                    ...milestones.map((milestone) => ({
                        x: milestone.time / 1000,
                        y: 0,
                    })),
                ],
            },
        ],
    };

    const chartOptions = {
        ...options,

        responsive: true,
        interaction: {
            intersect: false,
            mode: 'nearest',
        },
        scales: {
            x: {
                type: 'linear',
                active: false,
                title: {
                    text: 'Time (in seconds)',
                    display: true,
                },
            },
            y: {
                type: 'linear',
                title: {
                    text: `${metric} (in ${unit})`,
                    display: true,
                },
                ticks: {
                    fontSize: 20,
                },
            },
        },
        milestones,
        plugins: {
            legend: {
                labels: {
                    filter: function (item, chart) {
                        // Logic to remove a particular legend item goes here
                        return item.text.includes(title);
                    },
                },
            },

            tooltip: {
                callbacks: {
                    title: function (tooltipItems) {
                        const parsedX = tooltipItems[0].parsed.x;
                        const milestone = milestones.find(
                            (milestone) => milestone.time / 1000 === parsedX
                        );

                        return milestone ? milestone.title : tooltipItems[0].label + 's';
                    },
                    label: function (tooltipItem) {
                        return (
                            tooltipItem.datasetIndex < yDatasets.length &&
                            tooltipItem.formattedValue
                        );
                    },
                },
            },
        },
    };

    return <Line data={chartData} options={chartOptions}></Line>;
}

MetricChart.propTypes = {
    title: PropTypes.string,
    metric: PropTypes.string,
    unit: PropTypes.string,
    yDatasets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    options: PropTypes.object,
    milestones: MilestonesPropType,
};

export default MetricChart;
